module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if (value.removed) { 
    ; __append("\n\n<b>УДАЛЁН</b>\n\n")
    ;  } else { 
    ; __append("\n\n")
    ;  if (value.vehicle) { 
    ; __append("\n<div>\n	")
    ; __append( card.render("Vehicle", {value: value.vehicle, mode: mode}) )
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}